import {
	SEARCH_PARTS_PENDING,
	SEARCH_PARTS_SUCCESS,
	SEARCH_PARTS_FAILED,
	REQUEST_PARTS_PENDING,
	REQUEST_PARTS_SUCCESS,
	REQUEST_PARTS_FAILED,
	GET_SKILL_INFO_PENDING,
	GET_SKILL_INFO_SUCCESS,
	GET_SKILL_INFO_FAILED,
	SORT_PARTS,
	CHANGE_SORT_DIR,
	SET_FILTERS,
	GET_SERIES_PENDING,
	GET_SERIES_SUCCESS,
	GET_SERIES_FAILED,
	GET_SKILLS_PENDING,
	GET_SKILLS_SUCCESS,
	GET_SKILLS_FAILED,
	GET_WORDTAGS_PENDING,
	GET_WORDTAGS_SUCCESS,
	GET_WORDTAGS_FAILED,	
	ADD_PARTS_PENDING,
	ADD_PARTS_SUCCESS,
	ADD_PARTS_FAILED,
	ADD_SKILL_PENDING,
	ADD_SKILL_SUCCESS,
	ADD_SKILL_FAILED,
	CHANGE_VIEW,
	STATUS_TEXT,
	ADD_PART_STATUS_TEXT,
	ADD_SKILL_STATUS_TEXT,
	REFRESH_SKILL_STATUS_TEXT,
} from './constants';

const initialStateParts = {
	searchText: '',
	searchMatchType: 'and',
	searchError: false,
	isPending: false,
	isSearchPending: false,
	listedParts: [],
	listedPartJSONString: '',
	searchResultIds: [],
	error: '',
	filters: {
		rarity: ['1','2','3','4','5'],
		part: [
			'Head', 'Chest', 'Arms', 'Legs', 'Backpack', 'Shield',
			'Axe', 'Saber', 'Fist Module', 'Claw Module', 'Blade', 'Lance', 'Dual Saber', 'Twin Blade',
			'Rifle', 'Machinegun', 'Long Rifle', 'Gatling Gun', 'Bazooka', 'Whip',
			'All Rounder', 'Defender', 'In-Fighter', 'Out-Fighter', 'Middle-Shooter', 'Long-Shooter', 'Supporter',
		],
	},
	sortBy: 'armor',
	sortDir: 'hightolow',
};

const initialStateSkills = {
	pendingSkills: [],
	skillInfo: {},
	skills: [],
};

const initialStateCrud = {
	series: [],
	skills: [],
	wordtags: [],
	parts: [],
	skill: [],
	isSeriesPending: false,
	isSkillsPending: false,
	isWordtagsPending: false,
	isAddPartsPending: false,
	isAddSkillPending: false,
	addPartStatusText: '',
	addSkillStatusText: '',
	refreshSkillStatusText: '',
};

const initialStateUI = {
	displayView: 'list',
	statusText: '',
};

export const crud = (state=initialStateCrud, action={}) => {

	switch(action.type) {

		case GET_SERIES_PENDING:

			return { ...state, isSeriesPending: true };
		case GET_SERIES_SUCCESS:

			return { ...state, series: action.payload, isSeriesPending: false };
		case GET_SERIES_FAILED:

			return { ...state, error: action.payload, isSeriesPending: false };
		case GET_WORDTAGS_PENDING:

			return { ...state, isWordtagsPending: true };
		case GET_WORDTAGS_SUCCESS:

			return { ...state, wordtags: action.payload, isWordtagsPending: false };
		case GET_WORDTAGS_FAILED:

			return { ...state, error: action.payload, isWordtagsPending: false };
		case GET_SKILLS_PENDING:

			return { ...state, isSkillsPending: true };
		case GET_SKILLS_SUCCESS:

			return { ...state, skills: action.payload, isSkillsPending: false };
		case GET_SKILLS_FAILED:

			return { ...state, error: action.payload, isSkillsPending: false };
		case ADD_PART_STATUS_TEXT:

			return { ...state, addPartStatusText: action.payload };
		case ADD_PARTS_PENDING:

			return { ...state, isAddPartsPending: true };
		case ADD_PARTS_SUCCESS:

			return { ...state, parts: action.payload, isAddPartsPending: false };
		case ADD_PARTS_FAILED:

			return { ...state, error: action.payload, isAddPartsPending: false };
		case ADD_SKILL_PENDING:

			return { ...state, isAddSkillPending: true };
		case ADD_SKILL_SUCCESS:

			return { ...state, skill: action.payload, isAddSkillPending: false };
		case ADD_SKILL_FAILED:

			return { ...state, error: action.payload, isAddSkillPending: false };
		case ADD_SKILL_STATUS_TEXT:

			return { ...state, addSkillStatusText: action.payload };
		case REFRESH_SKILL_STATUS_TEXT:

			return { ...state, refreshSkillStatusText: action.payload };
		default:
			return state;
	}
};

export const getParts = (state=initialStateParts, action={}) => {

	switch(action.type) {

		case REQUEST_PARTS_PENDING:

			return { ...state, isPending: true };
		case REQUEST_PARTS_SUCCESS:

			return { ...state, listedParts: action.payload, listedPartJSONString: JSON.stringify(action.payload), isPending: false };
		case REQUEST_PARTS_FAILED:

			return { ...state, error: action.payload, isPending: false };
		case SEARCH_PARTS_PENDING:

			return { ...state, searchText: action.payload, isSearchPending: true };
		case SEARCH_PARTS_SUCCESS:

			return { ...state,
				searchResultIds: action.payload['resultIds'],
				searchText: action.payload['searchText'],
				searchMatchType: action.payload['searchMatchType'],
				isSearchPending: false,
			};
		case SEARCH_PARTS_FAILED:

			return { ...state, searchError: action.payload };
		case SORT_PARTS:

			return { ...state, sortBy: action.payload };
		case CHANGE_SORT_DIR:

			return { ...state, sortDir: action.payload };
		case SET_FILTERS:

			return { ...state, filters: action.payload };
		default:
			return state;
	}
};

export const getInfo = (state=initialStateSkills, action={}) => {

	switch(action.type) {

		case GET_SKILL_INFO_PENDING:

			const pending = state.pendingSkills.concat(action.payload);
			return { ...state, pendingSkills: pending };
		case GET_SKILL_INFO_SUCCESS:

			const newSkillList = state.skills.concat(action.payload);

			const skillId = action.payload[0].skill_id;
			const filteredPending = state.pendingSkills.filter((id) => {

				return id !== skillId;
			});

			return { ...state, skillInfo: action.payload, skills: newSkillList, pendingSkills: filteredPending };
		case GET_SKILL_INFO_FAILED:

			return { ...state, error: action.payload };
		default:
			return state;
	}
};

export const updateUI = (state = initialStateUI, action = {}) => {

	switch (action.type) {

		case CHANGE_VIEW:
			return { ...state, displayView: action.payload };

		case STATUS_TEXT:

			return { ...state, statusText: action.payload };

		default:
			return state;
	}
};